// Thông báo từ TCT
export const GET_LIST_NOTICE_FROM_TCT = "GET_LIST_NOTICE_FROM_TCT";
export const GET_LIST_NOTICE_FROM_TCT_SUCCESS =
  "GET_LIST_NOTICE_FROM_TCT_SUCCESS";
export const GET_LIST_NOTICE_FROM_TCT_FAIL = "GET_LIST_NOTICE_FROM_TCT_FAIL";
export const RESET_LIST_NOTICE_FROM_TCT = "RESET_LIST_NOTICE_FROM_TCT";
//
export const SET_COLUMN_VISIBLE_NOTICE_FROM_TCT =
  "SET_COLUMN_VISIBLE_NOTICE_FROM_TCT";
